import { render } from "./CardAccountGroup.vue?vue&type=template&id=280c2322&scoped=true"
import script from "./CardAccountGroup.vue?vue&type=script&lang=js"
export * from "./CardAccountGroup.vue?vue&type=script&lang=js"

import "./CardAccountGroup.vue?vue&type=style&index=0&id=280c2322&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280c2322"]])

export default __exports__